import React from "react";
import {useFeatureFlags} from "utilities/featureUtil";
import Dashboard from "./Dashboard";
import DashboardV2 from "./DashboardV2";

const DashboardPage = () => {
  const flags = useFeatureFlags();

  return flags["dashboard-v2"] ? <DashboardV2 /> : <Dashboard />;
};

export default DashboardPage;
